// Shown under the upload controls in the upload modal and the photos tray.
export const ACCEPTED_FORMATS_NOTE =
  '* Upload jpeg, jpg, png, pdf, heic, heif or avif image formats.';
